export default {
   methods: {
       getMockAffiliateLinks(activation) {
           if(!activation.conversion_configs){
               return [];
           }

           return activation.conversion_configs.filter((config) => config.affiliate_group_id).map((config, index) => {
               return {
                   link_id:   config.affiliate_group_id,
                   short_url: `https://fake-affiliates.fake/dundermiflin/${index+1}`,
               };
           });
       },
       getMockDiscountCodes(activation) {
           if(!activation.conversion_configs){
               return [];
           }

           return activation.conversion_configs.filter((config) => config.discount_group_id).map((config, index) => {
               return {
                   group_id: config.discount_group_id,
                   code:     `fakediscountcode${index+1}`,
               };
           });
       },
   },
};
